module.exports = __webpack_public_path__ + "img/send-work.a1f3d506.png";